import { faMagnifyingGlassPlus } from "@fortawesome/pro-regular-svg-icons";
import { useImagePreviewHandlers } from "../../image-preview-context";
import { Tool } from "./tool";
import { ToolboxToolProps } from "./toolbox.types";

/**
 * Zoom In tool for the ImagePreview toolbox.
 */
export const ZoomIn = (props: ToolboxToolProps) => {
    const handlers = useImagePreviewHandlers();
    return <Tool icon={faMagnifyingGlassPlus} label="Zoom In" onClick={handlers.zoomIn} {...props} />;
};
